import { FormBuilderSchema } from "../../../modules/FormBuilderCore/Types"

export type BaseWorkflowTaskModel = {
	id: number
	declaredActivityInstanceId: number
	name: string
	workflowTaskTypeId: string
	assignmentType: AssignmentType
	assignmentTargetId: number
	workflowTaskStatus: WorkflowTaskStatus
	lockedUntil: Date
	createdDate: Date
	createdBy: number
}

export type BaseWorkflowTaskState = {
	'$t': string
	workflowTaskTypeId: string
}

export type WorkflowTaskResponse<TState extends BaseWorkflowTaskState> = {
	id: number
	declaredActivityInstanceId: number
	name: string
	workflowTaskState: TState
	assignmentType: AssignmentType
	assignmentTargetId: number
	formBuilderSchema: FormBuilderSchema // ! Remove Me!!!
	workflowTaskStatus: WorkflowTaskStatus
}

export type NewWorkflowTaskModel = {
	declaredActivityInstanceId: number
	name: string
	workflowTaskTypeId: string
	assignmentType: AssignmentType
	assignmentTargetId: number
}

export type ReadWorkflowTaskModel<TState extends BaseWorkflowTaskState> = WorkflowTaskResponse<TState>

export type WriteWorkflowTaskModel<TState extends BaseWorkflowTaskState> = {
	lockPassword: string
} & WorkflowTaskResponse<TState>

export type WorkflowTaskResult = {
	results: unknown
	lockPassword: string
	userId?: number
	logMessage?: string
}

export type WorkflowTaskQueueSnapshot = {
	assignmentType: AssignmentType
	assignedTo: number
	itemCount: number
}

export type ForwardedFormPackageWorkflowTaskState = {
	packageInstanceId: number
	packageId: number
	packageVersionId: number
	packageName: string
	description?: string
	instanceUserId: number
	lifetimeId: string
	uniqueInstanceId: string
} & BaseWorkflowTaskState

export type AssignedFormPackagesWithChangeToken = {
	rowVersion: string,
	workflowTask: WorkflowTaskResponse<ForwardedFormPackageWorkflowTaskState>
}

export enum AssignmentType {
	AnonymousLink = 0,
	Group = 1,
	User = 2
}

export enum WorkflowTaskPermissions {
	Read = 0,
	Write = 1
}

export enum WorkflowTaskState {
	All = 0,
	Unlocked = 1,
	Locked = 2,
	Active = 3,
	Done = 4
}

export enum WorkflowTaskStatus {
	Active = 0,
	Done = 1
}